module.exports = __webpack_public_path__ + "static/media/configuracoes.886c6973.png";